import axios from "axios";
import fileDownload from "js-file-download";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const listPL = async (params: any) => {
  const { data: response } = await axios.get(endpoints.PL, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const downloadPL = async (params: any) => {
  await axios
    .get(endpoints.PL_EXPORT, {
      headers: {
        Authorization: accessToken,
        ContentType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      params,
      responseType: "arraybuffer",
    })
    .then((res) => {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileDownload(blob, `pl_${params.date_start}_${params.date_end}.xlsx`);
    });
};

const getSummaryBranch = async (params: any) => {
  const { data: response } = await axios.get(endpoints.PL_SUMMARY_BRANCH, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const downloadSummaryBranch = async (params: any) => {
  await axios
    .get(endpoints.PL_DOWNLOAD_BRANCH, {
      headers: {
        Authorization: accessToken,
        ContentType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      params,
      responseType: "arraybuffer",
    })
    .then((res) => {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileDownload(blob, `pl_summary_branch_${params.date_start}_${params.date_end}.xlsx`);
    });
};

const getSummaryRegion = async (params: any) => {
  const { data: response } = await axios.get(endpoints.PL_SUMMARY_REGION, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const downloadSummaryRegion = async (params: any) => {
  await axios
    .get(endpoints.PL_DOWNLOAD_REGION, {
      headers: {
        Authorization: accessToken,
        ContentType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      params,
      responseType: "arraybuffer",
    })
    .then((res) => {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileDownload(blob, `pl_summary_region_${params.date_start}_${params.date_end}.xlsx`);
    });
};

const getPL = async (id: number | string) => {
  const { data: response } = await axios.get(endpoints.DETAIL_PL(Number(id)), {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const createPL = async (params: any) => {
  const { data: response } = await axios.post(endpoints.PL, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const updatePL = async (id: number | string, params: any) => {
  const { data: response } = await axios.patch(endpoints.DETAIL_PL(Number(id)), params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const downloadBulkTemplate = async () => {
  await axios
    .get(endpoints.PL_DOWNLOAD_TEMPLATE, {
      headers: {
        Authorization: accessToken,
        ContentType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "arraybuffer",
    })
    .then((res) => {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileDownload(blob, "pl_bulk_template.xlsx");
    });
};

const uploadBulkTemplate = async (params: FormData) => {
  const { data: response } = await axios.post(endpoints.PL_UPLOAD_TEMPLATE, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const downloadMutasiTemplate = async () => {
  await axios
    .get(endpoints.PL_DOWNLOAD_MUTASI_TEMPLATE, {
      headers: {
        Authorization: accessToken,
        ContentType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "arraybuffer",
    })
    .then((res) => {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileDownload(blob, "pl_mutasi_template.xlsx");
    });
};

const uploadMutasiTemplate = async (params: FormData) => {
  const { data: response } = await axios.post(endpoints.PL_UPLOAD_MUTASI_TEMPLATE, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const getBEP = async () => {
  const { data: response } = await axios.get(endpoints.PL_BEP, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const downloadBEP = async () => {
  await axios
    .get(endpoints.PL_BEP_EXPORT, {
      headers: {
        Authorization: accessToken,
        ContentType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "arraybuffer",
    })
    .then((res) => {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileDownload(blob, "pl_bep.xlsx");
    });
};

const plService = {
  listPL,
  downloadPL,
  getSummaryBranch,
  downloadSummaryBranch,
  getSummaryRegion,
  downloadSummaryRegion,
  getPL,
  createPL,
  updatePL,
  downloadBulkTemplate,
  uploadBulkTemplate,
  downloadMutasiTemplate,
  uploadMutasiTemplate,
  getBEP,
  downloadBEP,
};

export default plService;
